import BC from '../init';

export default BC.Methods.addView = () => {

    const postId = croatiaPageID;
    console.log('add view', croatiaPageID);
    let viewedPosts = localStorage.getItem('viewedPosts');
    viewedPosts = viewedPosts ? JSON.parse(viewedPosts) : [];

    if (!viewedPosts.includes(postId)) {
        viewedPosts.push(postId);
        localStorage.setItem('viewedPosts', JSON.stringify(viewedPosts));

        try {
            const changeUrl = MyScriptVars.rest_url + 'view';
            const viewsResponse = fetch(changeUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: new Headers({
                    'X-WP-Nonce': MyScriptVars.nonce,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({ post_id: postId })
            });
            if (!viewsResponse.ok) throw new Error('Network response was not ok for views');
        } catch (e) {
            console.log(e);
        }
    }
};
